import clsx from 'clsx';

type Props = {
  icon: string | React.ReactNode;
  className?: string;
};
export function SelectItemIcon({
  className,
  ...props
}: Props): React.JSX.Element {
  const cn = clsx('mr-3 h-5 w-5 shrink-0 rounded-full', className);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {typeof props.icon === 'string' ? (
        <img src={props.icon} alt="icon" className={cn} aria-hidden="true" />
      ) : (
        props.icon
      )}
    </>
  );
}

SelectItemIcon.displayName = 'SelectItemIcon';
